"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _peractoConfig = require("@peracto/peracto-config");

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Textarea = function Textarea(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      label = _ref.label;

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var editorRef = (0, _react.useRef)();

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      editorLoaded = _useState4[0],
      setEditorLoaded = _useState4[1];

  var _ref2 = editorRef.current || {},
      CKEditor = _ref2.CKEditor,
      ClassicEditor = _ref2.ClassicEditor;

  var config = (0, _peractoConfig.useConfig)();

  var _ref3 = config.get('editorConfig') || [],
      colorOptions = _ref3.colorOptions,
      _ref3$headings = _ref3.headings,
      headings = _ref3$headings === void 0 ? [] : _ref3$headings;

  var themeColours = colorOptions ? colorOptions.map(function (colour) {
    return {
      label: colour.label,
      color: colour.value
    };
  }) : [];
  var defaultHeadings = (ClassicEditor === null || ClassicEditor === void 0 ? void 0 : ClassicEditor.defaultConfig.heading.options.filter(function (opt) {
    return opt.model !== 'paragraph';
  })) || [];
  var defaultParagraph = (ClassicEditor === null || ClassicEditor === void 0 ? void 0 : ClassicEditor.defaultConfig.heading.options.find(function (opt) {
    return opt.model === 'paragraph';
  })) || [];
  var customHeadingModels = headings.map(function (heading) {
    return heading.model;
  });
  var filteredDefaultHeadings = defaultHeadings.filter(function (heading) {
    return !customHeadingModels.includes(heading.model);
  });
  var combinedHeadings = [].concat(_toConsumableArray(filteredDefaultHeadings), _toConsumableArray(headings));
  var sortedHeadings = (0, _sortBy["default"])(combinedHeadings, 'model');
  (0, _react.useEffect)(function () {
    setData(value);

    var _require = require('@peracto/ckeditor'),
        ClassicEditor = _require.ClassicEditor;

    var _require2 = require('@ckeditor/ckeditor5-react'),
        CKEditorReact = _require2.CKEditor;

    editorRef.current = {
      CKEditor: CKEditorReact,
      ClassicEditor: ClassicEditor
    };
    setEditorLoaded(true);
  }, [value]);
  return editorLoaded && /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group mb-2",
    "data-testid": "".concat(label.toLowerCase().replaceAll(' ', '-'), "-section")
  }, label && /*#__PURE__*/_react["default"].createElement("label", {
    className: "mb-1"
  }, label), /*#__PURE__*/_react["default"].createElement(CKEditor, {
    editor: ClassicEditor,
    data: data,
    config: {
      toolbar: {
        items: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'alignment', '|', 'indent', 'outdent', '|', 'fontColor', '|', 'blockQuote', 'horizontalLine', 'insertTable', 'mediaEmbed', 'ckfinder', '|', 'undo', 'redo', 'removeFormat']
      },
      placeholder: 'Enter your text here...',
      fontColor: {
        colors: [].concat(_toConsumableArray(themeColours), [// we need to include the defaults here otherwise they get removed :(
        {
          color: 'hsl(0, 0%, 0%)',
          label: 'Black'
        }, {
          color: 'hsl(0, 0%, 30%)',
          label: 'Dim grey'
        }, {
          color: 'hsl(0, 0%, 60%)',
          label: 'Grey'
        }, {
          color: 'hsl(0, 0%, 90%)',
          label: 'Light grey'
        }, {
          color: 'hsl(0, 0%, 100%)',
          label: 'White',
          hasBorder: true
        }, {
          color: 'hsl(0, 75%, 60%)',
          label: 'Red'
        }, {
          color: 'hsl(30, 75%, 60%)',
          label: 'Orange'
        }, {
          color: 'hsl(60, 75%, 60%)',
          label: 'Yellow'
        }, {
          color: 'hsl(90, 75%, 60%)',
          label: 'Light green'
        }, {
          color: 'hsl(120, 75%, 60%)',
          label: 'Green'
        }, {
          color: 'hsl(150, 75%, 60%)',
          label: 'Aquamarine'
        }, {
          color: 'hsl(180, 75%, 60%)',
          label: 'Turquoise'
        }, {
          color: 'hsl(210, 75%, 60%)',
          label: 'Light blue'
        }, {
          color: 'hsl(240, 75%, 60%)',
          label: 'Blue'
        }, {
          color: 'hsl(270, 75%, 60%)',
          label: 'Purple'
        }])
      },
      heading: {
        options: [defaultParagraph].concat(_toConsumableArray(sortedHeadings))
      }
    },
    onChange: onChange
  }));
};

var _default = Textarea;
exports["default"] = _default;